import { primaryThemeBreakpoints } from "./primaryThemeBreakpoints";
import { primaryThemeColors } from "./primaryThemeColors";
import { primaryThemeFonts } from "./primaryThemeFonts";

const primary = {
  colors: primaryThemeColors,
  font: primaryThemeFonts,
  breakpoints: primaryThemeBreakpoints,
};

export default primary;
